module.exports = __webpack_public_path__ + "video-4e9133934d52.mov";